const hasContexts = (contexts: Array<string>) => contexts.every(context => window.contexts.includes(context));

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['pdp']),
    load: () =>
        Promise.all([import(/* webpackChunkName: 'product.widgets' */ './widgets/product/TabbyProductDetails').then(d => d.default)]).then(deps => {
            const [TabbyProductDetails] = deps;

            return {
                listId: 'product.widgets.tabby',
                widgetsDefinition: () => [['productDetail', TabbyProductDetails, 'productDetail']]
            };
        })
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout']),
    load: () =>
        Promise.all([import(/* webpackChunkName: 'checkout.tabby' */ './widgets/checkout/PaymentAccordionItemTABBY').then(d => d.default)]).then(
            deps => {
                const [PaymentAccordionItemTABBY] = deps;

                return {
                    listId: 'checkout.TABBY',
                    widgetsDefinition: () => [['paymentAccordionItemTABBY', PaymentAccordionItemTABBY, 'paymentAccordionItem']]
                };
            }
        )
});
